import "./style.less";
export default function bpRow() {
    return {
        restrict: "E",
        scope: {
            bp: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, moment, Basket) {
            const bp = $scope.bp;

            // Set collapse onload state
            $scope.isCollapsed = true;

            $scope.activity = Basket.getBookingActivity();
            $scope.location = Basket.getBookingLocation();

            $scope.setDateString = function () {
                // Default timespan is same day
                const fromTime = moment(bp.start).format("HH:mm");

                const ToTime = moment(bp.end).format("HH:mm");

                $scope.timeString = fromTime + " - " + ToTime;
            };
            $scope.setDateString();
        },
    };
}
